import script from "./MainstayDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainstayDialog.vue?vue&type=script&setup=true&lang=ts"

import "./MainstayDialog.vue?vue&type=style&index=0&id=15393b7a&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15393b7a"]])

export default __exports__